export default __webpack_public_path__ + "static/media/729.625e9ba4.gif";